import React, { useEffect, useState, useCallback } from 'react';
import { injectIntl } from "react-intl";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import { useHistory } from 'react-router-dom';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/usersLabs/actions';
import { arabicConvertor } from '../../utils/Shared';
import PhoneInputComponent from '../Controls/PhoneInput/PhoneInput';
import { validateEmailRequest, validateMobileRequest } from '../../store/users/actions';
import moment from 'moment';

function UsersHospitalsForm({ intl: { messages }, hospital }) {
    const history = useHistory();
    const dispatch = useDispatch();
    const { cities } = useSelector((state) => state?.usersLabs);
    const { valideEmail, emailError, valideMobile, mobileError } = useSelector(state => state?.users);
    const [cancelConfirmation, setCancelConfirmation] = useState(false);
    const [feedback, setFeedback] = useState('');
    const [citiesList, setCitiesList] = useState([]);
    const lang = localStorage.getItem('lang');

    useEffect(() => {
        dispatch(actions.getCitiesRequest());
    }, [dispatch]);

    useEffect(() => {
        if (cities) {
            setCitiesList(cities);
        }
    }, [cities]);

    const daysList = [
        messages.users.form.sunday,
        messages.users.form.monday,
        messages.users.form.tuesday,
        messages.users.form.wednesday,
        messages.users.form.thursday,
        messages.users.form.friday,
        messages.users.form.saturday,
    ];

    const [formData, setFormData] = useState({
        id: null,
        code: '',
        name: {
            en: '',
            ar: ''
        },
        role_id: 8,
        city_id: 0,
        username: '',
        map_link: '',
        user_name: {
            en: '',
            ar: ''
        },
        user_position: '',
        phone_number: '',
        email: '',
        schedules: [
            {
                day: 1,
                from_hour: '08:00',
                to_hour: '16:00',
                is_working_day: true,
            },
            {
                day: 2,
                from_hour: '08:00',
                to_hour: '16:00',
                is_working_day: true,
            },
            {
                day: 3,
                from_hour: '08:00',
                to_hour: '16:00',
                is_working_day: true,
            },
            {
                day: 4,
                from_hour: '08:00',
                to_hour: '16:00',
                is_working_day: true,
            },
            {
                day: 5,
                from_hour: '08:00',
                to_hour: '16:00',
                is_working_day: true,
            },
            {
                day: 6,
                from_hour: '08:00',
                to_hour: '16:00',
                is_working_day: false,
            },
            {
                day: 7,
                from_hour: '08:00',
                to_hour: '16:00',
                is_working_day: false,
            },
        ],
    });

    const clear = () => {
        setFormData({
            id: null,
            code: '',
            name: {
                en: '',
                ar: ''
            },
            role_id: 8,
            city_id: 0,
            username: '',
            map_link: '',
            user_name: {
                en: '',
                ar: ''
            },
            user_position: '',
            phone_number: '',
            email: '',
            schedules: [
                {
                    day: 1,
                    from_hour: '08:00',
                    to_hour: '16:00',
                    is_working_day: true,
                },
                {
                    day: 2,
                    from_hour: '08:00',
                    to_hour: '16:00',
                    is_working_day: true,
                },
                {
                    day: 3,
                    from_hour: '08:00',
                    to_hour: '16:00',
                    is_working_day: true,
                },
                {
                    day: 4,
                    from_hour: '08:00',
                    to_hour: '16:00',
                    is_working_day: true,
                },
                {
                    day: 5,
                    from_hour: '08:00',
                    to_hour: '16:00',
                    is_working_day: true,
                },
                {
                    day: 6,
                    from_hour: '08:00',
                    to_hour: '16:00',
                    is_working_day: false,
                },
                {
                    day: 7,
                    from_hour: '08:00',
                    to_hour: '16:00',
                    is_working_day: false,
                },
            ],
        });
        document.getElementById('code').style.borderColor = '#eee';
        document.getElementById('enname').style.borderColor = '#eee';
        document.getElementById('arname').style.borderColor = '#eee';
        document.getElementById('country').style.borderColor = '#eee';
        document.getElementById('username').style.borderColor = '#eee';
        document.getElementById('googlemap').style.borderColor = '#eee';
        document.getElementById('user_enname').style.borderColor = '#eee';
        document.getElementById('user_arname').style.borderColor = '#eee';
        document.getElementById('position').style.borderColor = '#eee';
        document.getElementById('email').style.borderColor = '#eee';
        document.getElementById('phone').style.borderColor = '#eee';
    }

    const rebuildSchedule = (schedule) => {
        let newSchedule = [];
        if (schedule) {
            daysList.forEach((day, index) => {
                let newItem = {
                    day: index + 1,
                    from_hour: schedule[index] ? schedule[index].from_hour : '',
                    to_hour: schedule[index] ? schedule[index].to_hour : '',
                    is_working_day: schedule[index] ? schedule[index].is_working_day : false,
                };
                newSchedule.push(newItem);
            });
        }
        return newSchedule;
    }

    useEffect(() => {
        if (hospital) {
            setFormData({
                id: hospital.id,
                code: hospital.code,
                name: {
                    en: hospital.name?.en,
                    ar: hospital.name?.ar
                },
                role_id: hospital.role_id,
                city_id: hospital.city_id,
                username: hospital.username,
                map_link: hospital.map_link,
                user_name: {
                    en: hospital.user_name?.en,
                    ar: hospital.user_name?.ar
                },
                user_position: hospital.user_position,
                phone_number: hospital.phone_number?.replace(/\+/g, ""),
                email: hospital.email,
                schedules: rebuildSchedule(hospital.schedules),
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hospital]);

     // Blur Event Callback - Email Input
     const blurEmail = useCallback((e) => {
        if (e.target.value !== '') {
            if (!hospital) {
                dispatch(validateEmailRequest(e.target.value));
            } else {
                if (hospital.email !== e.target.value) {
                    dispatch(validateEmailRequest(e.target.value));
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    // Handle Blur Event - Email input
    useEffect(() => {
        document.getElementById('email').addEventListener('blur', blurEmail);
        return () => {
            document.getElementById('email').removeEventListener('blur', blurEmail);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Validate Email input
    useEffect(() => {
        if (valideEmail || document.getElementById('email').value === '') {
            document.getElementById('email').style.borderColor = '#eee';
            setFeedback('');
        } else {
            document.getElementById('email').style.borderColor = '#d58c8c';
            setFeedback(emailError);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valideEmail, emailError]);

     // Blur Event Callback - Phone Input
    const blurPhone = useCallback((e) => {
        if (e.target.value !== '') {
            if (!hospital) {
                dispatch(validateMobileRequest(e.target.value));
            } else {
                if (hospital.phone_number !== `+${e.target.value}`) {
                    dispatch(validateMobileRequest(e.target.value));
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    // Handle Blur Event - Phone input
    useEffect(() => {
        document.getElementById('phone').addEventListener('blur', blurPhone);
        return () => {
            document.getElementById('phone').removeEventListener('blur', blurPhone);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //Validate Mobile input
    useEffect(() => {
        if (valideMobile || document.getElementById('phone').value === '') {
            document.getElementById('phone').style.borderColor = '#eee';
            setFeedback('');
        } else {
            document.getElementById('phone').style.borderColor = '#d58c8c';
            setFeedback(messages.users.form.phone_invalid);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valideMobile]);

    useEffect(() => {
        if (mobileError && mobileError.length > 0) {
            document.getElementById('phone').style.borderColor = '#d58c8c';
            setFeedback(mobileError);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mobileError]);

    // Validation
    const validation = () => {
        let isValid = true;

        if (formData.username === '') {
            document.getElementById('username').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.usersHospitals.form.username_placeholder);
        }
        if (formData.map_link === '') {
            document.getElementById('googlemap').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.usersHospitals.form.google_placeholder);
        }
        if (formData.city_id === 0) {
            document.getElementById('country').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.usersHospitals.form.cities_error);
        }
        if (formData.name.en === '') {
            document.getElementById('enname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.usersHospitals.form.en_name_invalid);
        }
        if (formData.name.ar === '') {
            document.getElementById('arname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.usersHospitals.form.ar_name_invalid);
        }
        if (formData.code === '') {
            document.getElementById('code').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.usersHospitals.form.code_placeholder);
        }
        if (formData.code === '' && formData.name.ar === '' && formData.name.en === '' && formData.username === '' && formData.map_link === '' && formData.city_id === 0) {
            setFeedback(messages.usersHospitals.form.allRequired);
        }

        return isValid;
    }

    const userValidation = () => {
         // User Validation
        let isValid = true;

        if (formData.role_id === '') {
            document.getElementById('position').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.position_invalid);
        }
        if (formData.name.ar === '') {
            document.getElementById('user_arname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.ar_name_invalid);
        }
        if (formData.name.en === '') {
            document.getElementById('user_enname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.en_name_invalid);
        }
        if (formData.phone_number === '' || !valideMobile) {
            document.getElementById('phone').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.phone_invalid);
        }
        if (formData.email === '' || !valideEmail) {
            document.getElementById('email').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.email_invalid);
        }
        return isValid;
    }

    const schedulesValidation = () => {
        let validScedules = true;
        formData.schedules?.map((item) => {
            if (item.is_working_day) {
                if (moment(item.to_hour, 'HH:mm').diff(moment(item.from_hour, 'HH:mm'), 'minutes') < 120) {
                    setFeedback(messages.users.form.schedule_invalid_2h);
                    validScedules = false;
                }
                /* if (!moment(item.to_hour, 'HH:mm').isValid() || !moment(item.from_hour, 'HH:mm').isValid()) {
                    setFeedback(messages.users.form.time_invalid);
                    validScedules = false;
                } */
                if (item.to_hour === '' || item.from_hour === '') {
                    setFeedback(messages.users.form.working_hours_invalid);
                    validScedules = false;
                }
            }
            return item
        })
        return validScedules;
    }

    // Save Function
    const handleSave = (e) => {
        e.preventDefault()
        if (validation() && userValidation() && schedulesValidation()) {
            setFeedback('');
            let mySchedules = [];
            formData.schedules?.forEach((item) => {
                if (item.is_working_day) {
                    mySchedules.push({
                        day: item.day,
                        from_hour: item.from_hour,
                        to_hour: item.to_hour,
                    })
                }
            })
            if (hospital) {
                dispatch(actions.editUsersLabRequest({...formData, schedules: mySchedules, phone_number: `+${formData.phone_number}`}, history));
            } else {
                dispatch(actions.addUsersLabRequest({...formData, schedules: mySchedules, phone_number: `+${formData.phone_number}`}, history));
            }
        }
    }

    // Cancel Function
    const handleCancel = (e) => {
        e.preventDefault();
        if (hospital) {
            if (formData.code === hospital.code && formData.name.en === hospital.name.en && formData.name.ar === hospital.name.ar && formData.username_name === hospital.username_name && formData.city_id === hospital.city_id && formData.map_link === hospital.map_link) {
                history.push(`/users/hospitals`);
            } else {
                setCancelConfirmation(true);
            }
        } else {
            if (formData.code === '' && formData.name.en === '' && formData.name.ar === '' && formData.username_name === '' && formData.city_id === 0 && formData.map_link === '') {
                history.push(`/users/hospitals`);
            } else {
                setCancelConfirmation(true);
            }
        }
    }

    //console.log(reference);

    return (
        <div className='userform_container myform'>
            <form>
                <h3>{messages.usersHospitals.form.title}</h3>
                <div className="row">
                    <div className="col-md-4">
                        <label htmlFor="code" className='required'>{messages.usersHospitals.form.code}</label>
                        <input type="text" name="code" id="code" autoFocus={true}
                                placeholder={messages.usersHospitals.form.code_placeholder}
                                value={formData.code}
                                onChange={e => {
                                    const re = /^[A-Za-z]+$/;
                                    if (e.target.value === "" || re.test(e.target.value)) {
                                        document.getElementById('code').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, code: e.target.value })
                                    }
                                    }} />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="arname" className='required'>{messages.usersHospitals.form.ar_name}</label>
                        <input type="text" name="arname" id="arname" 
                                placeholder={messages.usersHospitals.form.ar_name_placeholder}
                                value={formData.name.ar}
                                onChange={e => {
                                    document.getElementById('arname').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, name: { ...formData.name, ar: arabicConvertor(e.target.value) } })
                                    }} />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="enname" className='required'>{messages.usersHospitals.form.en_name}</label>
                        <input type="text" name="enname" id="enname"
                                placeholder={messages.usersHospitals.form.en_name_placeholder}
                                value={formData.name.en} 
                                onChange={e => {
                                    document.getElementById('enname').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, name: { ...formData.name, en: e.target.value } })
                                    }} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <label htmlFor="country" className='required'>{messages.usersHospitals.form.cities}</label>
                        <select name="country" id="country"
                                value={formData.city_id}
                                onChange={e => {
                                    document.getElementById('country').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, city_id: e.target.value })
                                    }}>
                            <option value={0}>{messages.usersHospitals.form.cities_placeholder}</option>
                            {citiesList?.map(city => <option key={city.id} value={city.id}>{city.name}</option>)}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="googlemap" className='required'>{messages.usersHospitals.form.google}</label>
                        <input type="googlemap" name="googlemap" id="googlemap"
                            placeholder={messages.usersHospitals.form.google_placeholder}
                            value={formData.map_link}
                            onChange={e => {
                                document.getElementById('googlemap').style.borderColor = '#eee';
                                setFeedback('');
                                setFormData({ ...formData, map_link: e.target.value })
                                }} />
                    </div>
                    <div className="col-md-4"></div>
                </div>
                <div className="row">
                <div className="col-md-4">
                        <label htmlFor="username" className='required'>{messages.usersHospitals.form.username}</label>
                        <input type="username" name="username" id="username"
                            placeholder={messages.usersHospitals.form.username_placeholder}
                            value={formData.username}
                            onChange={e => {
                                document.getElementById('username').style.borderColor = '#eee';
                                setFeedback('');
                                setFormData({ ...formData, username: e.target.value })
                                }} />
                    </div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4"></div>
                </div>
                <h3 className='mt-4'>{messages.usersHospitals.form.user_title}</h3>
                <div className="row">
                <div className="col-md-4">
                        <label htmlFor="email" className='required'>{messages.users.form.email}</label>
                        <input type="email" name="email" id="email"
                            placeholder={messages.users.form.email_placeholder}
                            value={formData.email}
                            onChange={e => {
                                document.getElementById('email').style.borderColor = '#eee';
                                setFeedback('');
                                setFormData({ ...formData, email: e.target.value })
                                }} />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="phone" className='required'>{messages.users.form.mobile}</label>
                            <PhoneInputComponent name="phone" id="phone" lang={lang}
                                myplaceholder={messages.users.form.mobile_placeholder}
                                myvalue={formData.phone_number}
                                onValueChange={(val) => {
                                    document.getElementById('phone').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, phone_number: val })
                                    }}
                                />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="position" className='required'>{messages.users.form.position}</label>
                        <input type="text" name="position" id="position"
                                placeholder={messages.usersHospitals.form.position_placeholder}
                                value={formData.user_position}
                                onChange={e => {
                                    document.getElementById('position').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, user_position: e.target.value })
                        }} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <label htmlFor="user_arname" className='required'>{messages.users.form.ar_name}</label>
                        <input type="text" name="user_arname" id="user_arname"
                                placeholder={messages.users.form.ar_name_placeholder}
                                value={formData.user_name.ar}
                                onChange={e => {
                                    document.getElementById('user_arname').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, user_name: { ...formData.user_name, ar: arabicConvertor(e.target.value) } })
                                    }} />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="user_enname" className='required'>{messages.users.form.en_name}</label>
                        <input type="text" name="user_enname" id="user_enname"
                                placeholder={messages.users.form.en_name_placeholder}
                                value={formData.user_name.en} 
                                onChange={e => {
                                    document.getElementById('user_enname').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, user_name: { ...formData.user_name, en: e.target.value } })
                                    }} />
                    </div>
                </div>
                <h3 style={{ marginTop: '20px' }}>{messages.users.form.scheduler_title}</h3>
                <div className="row" style={{ padding: "0 20px" }}>
                    <div className="col-md-6">
                        {
                            formData.schedules?.map((schedule, dayIndex) => (
                                dayIndex === 6 && <div key={dayIndex} className="row">
                                    <div className="col-md-4">
                                        <span>&nbsp;</span>
                                        <label className="checkbox-container">{daysList[dayIndex]}
                                            <input type="checkbox" checked={schedule?.is_working_day} 
                                                                onChange={e => setFormData({
                                                                        ...formData,
                                                                        schedules: formData.schedules?.map(item => {
                                                                                if (item.day === (dayIndex + 1)) {
                                                                                    return { 
                                                                                        ...item, 
                                                                                        is_working_day: e.target.checked,
                                                                                    }
                                                                                }
                                                                                return item
                                                                        })
                                                                })}/>
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                    <div className="col-md-4">
                                        <span>{messages.users.form.time_from}</span>
                                        <input step={900} type="time" placeholder='1 PM' value={schedule.from_hour} 
                                                                            onChange={e => setFormData({
                                                                                    ...formData,
                                                                                    schedules: formData.schedules?.map(item => {
                                                                                        if (item.day === (dayIndex + 1)) {
                                                                                            return { ...item, from_hour: e.target.value }
                                                                                        }
                                                                                        return item
                                                                                    })
                                                                            })}
                                                                            disabled={!schedule.is_working_day}/>
                                    </div>
                                    <div className="col-md-4">
                                        <span>{messages.users.form.time_to}</span>
                                        <input step={900} type="time" placeholder='1 PM' value={schedule.to_hour} 
                                                                            onChange={e => setFormData({
                                                                                    ...formData,
                                                                                    schedules: formData.schedules?.map(item => {
                                                                                        if (item.day === (dayIndex + 1)) {
                                                                                            return { ...item, to_hour: e.target.value }
                                                                                        }
                                                                                        return item
                                                                                    })
                                                                            })}
                                                                            disabled={!schedule.is_working_day}/>
                                    </div>
                                </div>
                            ))
                        }
                        {
                            formData.schedules?.map((schedule, dayIndex) => (
                                dayIndex < 3 && <div key={dayIndex} className="row">
                                    <div className="col-md-4">
                                        <span>&nbsp;</span>
                                        <label className="checkbox-container">{daysList[dayIndex]}
                                            <input type="checkbox" checked={schedule?.is_working_day} 
                                                                onChange={e => setFormData({
                                                                        ...formData,
                                                                        schedules: formData.schedules?.map(item => {
                                                                                if (item.day === (dayIndex + 1)) {
                                                                                    return { 
                                                                                        ...item, 
                                                                                        is_working_day: e.target.checked,
                                                                                    }
                                                                                }
                                                                                return item
                                                                        })
                                                                })}/>
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                    <div className="col-md-4">
                                        <span>{messages.users.form.time_from}</span>
                                        <input step={900} type="time" placeholder='1 PM' value={schedule.from_hour} 
                                                                            onChange={e => setFormData({
                                                                                    ...formData,
                                                                                    schedules: formData.schedules?.map(item => {
                                                                                        if (item.day === (dayIndex + 1)) {
                                                                                            return { ...item, from_hour: e.target.value }
                                                                                        }
                                                                                        return item
                                                                                    })
                                                                            })}
                                                                            disabled={!schedule.is_working_day}/>
                                    </div>
                                    <div className="col-md-4">
                                        <span>{messages.users.form.time_to}</span>
                                        <input step={900} type="time" placeholder='1 PM' value={schedule.to_hour} 
                                                                            onChange={e => setFormData({
                                                                                    ...formData,
                                                                                    schedules: formData.schedules?.map(item => {
                                                                                        if (item.day === (dayIndex + 1)) {
                                                                                            return { ...item, to_hour: e.target.value }
                                                                                        }
                                                                                        return item
                                                                                    })
                                                                            })}
                                                                            disabled={!schedule.is_working_day}/>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div className="col-md-6">
                        {
                            formData.schedules?.map((schedule, dayIndex) => (
                                dayIndex > 2 && dayIndex < 6 && <div key={dayIndex} className="row">
                                    <div className="col-md-4">
                                        <span>&nbsp;</span>
                                        <label className="checkbox-container">{daysList[dayIndex]}
                                            <input type="checkbox" checked={schedule?.is_working_day} 
                                                                onChange={e => setFormData({
                                                                        ...formData,
                                                                        schedules: formData.schedules?.map(item => {
                                                                                if (item.day === (dayIndex + 1)) {
                                                                                    return { 
                                                                                        ...item, 
                                                                                        is_working_day: e.target.checked,
                                                                                    }
                                                                                }
                                                                                return item
                                                                        })
                                                                })}/>
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                    <div className="col-md-4">
                                        <span>{messages.users.form.time_from}</span>
                                        <input step={900} type="time" placeholder='1 PM' value={schedule.from_hour} 
                                                                            onChange={e => setFormData({
                                                                                    ...formData,
                                                                                    schedules: formData.schedules?.map(item => {
                                                                                        if (item.day === (dayIndex + 1)) {
                                                                                            return { ...item, from_hour: e.target.value }
                                                                                        }
                                                                                        return item
                                                                                    })
                                                                            })}
                                                                            disabled={!schedule.is_working_day}/>
                                    </div>
                                    <div className="col-md-4">
                                        <span>{messages.users.form.time_to}</span>
                                        <input step={900} type="time" placeholder='1 PM' value={schedule.to_hour} 
                                                                            onChange={e => setFormData({
                                                                                    ...formData,
                                                                                    schedules: formData.schedules?.map(item => {
                                                                                        if (item.day === (dayIndex + 1)) {
                                                                                            return { ...item, to_hour: e.target.value }
                                                                                        }
                                                                                        return item
                                                                                    })
                                                                            })}
                                                                            disabled={!schedule.is_working_day}/>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className='form-footer'>
                    <p>&nbsp;{feedback}</p>
                    <div className="actions">
                        <button type="button" className="myBtn" onClick={(e) => handleSave(e)}>{messages.users.form.btn_save}</button>
                        <button type="button" className="myBtn cancel" onClick={e => {
                            handleCancel(e);
                        }}>{messages.users.form.btn_cancel}</button>
                    </div>
                </div>
            </form>
            <ConfirmDialog show={cancelConfirmation} 
                     onCancel={() => setCancelConfirmation(false)}
                     onConfirm={() => {
                        setCancelConfirmation(false);
                        clear();
                        history.push('/users/hospitals');
                     }}
                     icon={null}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
        </div>
    );
}

export default injectIntl(UsersHospitalsForm);